import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { MultiChipInputComponent } from './multi-chip-input.component';

@NgModule({
	imports: [CommonModule, FormsModule, MaterialModule],
	declarations: [MultiChipInputComponent],
	exports: [MultiChipInputComponent],
})
export class MultiChipInputModule {}
